import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { ArrowRight } from "lucide-react";

function RoleCard({ onClick, testid, selected, title, desc }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className={`w-full text-left rounded-2xl border p-6 transition-colors group ${selected ? "border-[#292827]" : "border-[#E6E1D9] hover:border-[#292827]"}`}>
      <div className="flex items-center justify-between gap-4">
        <div>
          <h3 className="text-[17px] font-semibold tracking-tightish text-[#292827]">{title}</h3>
          <p className="text-sm text-[#6E675C] mt-1">{desc}</p>
        </div>
        <ArrowRight size={20} className="text-[#968F85] group-hover:text-[#292827] group-hover:translate-x-1 transition-all shrink-0" />
      </div>
    </button>
  );
}

export default function RoleSelect() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const preset = params.get("rooli");
  const pick = (role) => navigate(`/rekisteroidy?rooli=${role}`);

  return (
    <AuthShell title="Aloitetaan" subtitle="Valitse ensin, kuka olet." testid="role-select-page">
      <div className="space-y-3">
        <RoleCard onClick={() => pick("creator")} testid="role-creator" selected={preset === "creator"}
          title="Olen sisällöntuottaja" desc="Luo profiili ja hae avoimiin kampanjoihin." />
        <RoleCard onClick={() => pick("business")} testid="role-business" selected={preset === "business"}
          title="Rekisteröidy yrityksenä" desc="Julkaise kampanjoita ja löydä sopivat sisällöntuottajat." />
      </div>
      <p className="mt-8 text-center text-sm text-[#6E675C]">
        Onko sinulla jo tili?{" "}
        <span className="font-medium text-[#292827] cursor-pointer hover:underline" onClick={() => navigate("/kirjaudu")} data-testid="to-login">Kirjaudu sisään</span>
      </p>
    </AuthShell>
  );
}
